import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function VersionCard({ versionName }) {
  const navigate = useNavigate();
  const [images, setImages] = useState([]);

  useEffect(() => {
    fetch("/images/index.json")
      .then((res) => res.json())
      .then((data) => {
        const filtered = data.filter(
          (item) => item.version === versionName
        );
        setImages(filtered);
      })
      .catch((err) => console.error("Error loading index.json:", err));
  }, [versionName]);

  // ✅ Prefer favorite → preview → first image
  const displayImage =
    images.find((img) => img.favorite) ||
    images.find((img) => img.preview) ||
    images[0] ||
    null;

  const handleClick = () => {
    // Convert "Version 1.x" → "1"
    const versionId = versionName
      .replace("Version ", "")
      .replace(".x", "")
      .toLowerCase();

    navigate(`/version/${versionId}`);
  };

  // ✅ Clean label (strip ".x")
  const cleanLabel = versionName.replace(".x", "");

  return (
    <div className="version-card" onClick={handleClick} style={{ cursor: "pointer" }}>
      {displayImage ? (
        <img
          src={displayImage.url}
          alt={`${cleanLabel} Preview`}
          className="version-image"
        />
      ) : (
        <div
          style={{
            height: "150px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#aaa",
          }}
        >
          No Preview
        </div>
      )}
      <h3 className="version-title">{cleanLabel}</h3>
    </div>
  );
}
